module.exports = __webpack_public_path__ + "static/media/manage.33edc432.png";